import { REGIONS, ENVS, Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const ISSUES_ENV_CONFIG_KEYS = {
  ISSUES_BE: 'ISSUES_BE',
  DOCS_FE: 'DOCS_FE'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: 'https://developer-stg.api.autodesk.com/issues-dev',
    [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360-dev.autodesk.com'
  },
  [ENVS.QA]: {
    [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: 'https://developer-stg.api.autodesk.com/issues-qa',
    [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360-qa.autodesk.com'
  },
  [ENVS.STAGING]: {
    [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: 'https://developer-stg.api.autodesk.com/issues-stg',
    [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360-staging.autodesk.com'
  },
  [ENVS.PROD]: {
    [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: 'https://developer.api.autodesk.com/issues',
    [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360.autodesk.com'
  }
};

export const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: US_CONFIG[ENVS.STAGING][ISSUES_ENV_CONFIG_KEYS.ISSUES_BE],
      [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      [ISSUES_ENV_CONFIG_KEYS.ISSUES_BE]: US_CONFIG[ENVS.PROD][ISSUES_ENV_CONFIG_KEYS.ISSUES_BE],
      [ISSUES_ENV_CONFIG_KEYS.DOCS_FE]: 'https://docs.b360.eu.autodesk.com'
    }
  }
};

export const Statuses = {
  DRAFT: 'draft',
  OPEN: 'open',
  ANSWERED: 'answered',
  CLOSED: 'closed',
  WORK_COMPLETED: 'work_completed',
  READY_TO_INSPECT: 'ready_to_inspect',
  NOT_APPROVED: 'not_approved',
  IN_DISPUTE: 'in_dispute',
  VOID: 'void'
};

export const statusColorMapping = {
  [Statuses.DRAFT]: Colors.GRAY_DARK,
  [Statuses.OPEN]: Colors.YELLOW,
  [Statuses.ANSWERED]: Colors.BLUE,
  [Statuses.CLOSED]: Colors.GRAY,
  [Statuses.WORK_COMPLETED]: Colors.BLUE,
  [Statuses.READY_TO_INSPECT]: Colors.PURPLE,
  [Statuses.NOT_APPROVED]: Colors.RED,
  [Statuses.IN_DISPUTE]: Colors.RED,
  [Statuses.VOID]: Colors.GRAY
};
